<template>
    <form action="" id="editBanner" class="formWrap" @submit.prevent="submitForm">
        <div class="row">
            <div class="col-xs-12 containerWidth">
                <div class="row">
                    <div class="col-sm-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="app_name">*{{ $t('app_name') }}</label>
                            <input type="text" id="app_name" name="app_name" v-model="name" required>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="app_domain">*{{ $t('app_domain') }}</label>
                            <input type="text" id="app_domain" name="app_domain"  v-model="domain" required>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                        <FileUpload v-on:uploaded="setFile" :label="'app_logo'" :placeHolder="'updateLogo'"></FileUpload>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                        <FileUpload v-on:uploaded="setFile" :label="'app_kiosk_logo'" :placeHolder="'updateKioskLogo'"></FileUpload>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="inputWrap submitWrap">
                            <button class="submit">{{ $t('save') }}</button>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </form>
</template>

<script>
    import FileUpload from '../../Common/FileUpload'
    export default {
        name: "AppSettingsTab",
        components:{
            FileUpload
        },
        data(){
            return{
                name:this.$store.state.user.app.name,
                domain:this.$store.state.user.app.domain,
                logo:'',
                kioskLogo:'',
            }
        },
        methods:{
            submitForm(){
                let _this = this;
                this.$store.dispatch('updateAppSettings',this.$data)
                                        .then(response =>{
                                            //success
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'success',
                                                title:this.$t('appSettingsUpdated'),
                                                timer:2000
                                            })
                                        })
                                        .catch(err => {
                                            //err
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'error',
                                                title:this.$t('fatalError'),
                                                timer:3000
                                            }).catch(this.$swal.noop);
                                        })
            },
            setFile(_,type){
                if(type === "app_logo"){
                    this.logo = _;
                } else {
                    this.kioskLogo = _;
                }
            },
        }
    }
</script>
